import React from 'react';
import { FormGroup, Label } from 'reactstrap';
import NumberInput from '../@core/components/number-input';

const InputNumber = ({
	wrap,
	min,
	max,
	step,
	value,
	style,
	vertical,
	disabled,
	readonly,
	onChange,
	className,
	onDecrement,
	onIncrement,
	inputClassName,
	size,
	caption,
	isRequired,
	errors
}) => {
	return (
		<FormGroup>
			<Label>
				{caption}
				{isRequired && <span style={{ color: 'red' }}>*</span>}
			</Label>
			<NumberInput
				wrap={wrap}
				min={min}
				max={max}
				step={step}
				value={value}
				style={style}
				vertical={vertical}
				disabled={disabled}
				readonly={readonly}
				onChange={onChange}
				className={className}
				onDecrement={onDecrement}
				onIncrement={onIncrement}
				inputClassName={inputClassName}
				size={size}
			/>
			{errors && (
				<Label className="form-label" style={{ color: 'red' }}>
					{errors}
				</Label>
			)}
		</FormGroup>
	);
};

export default InputNumber;
